import React from "react";
import {
    FUEL_LABELS,
    efficiencyUnit,
    formatDecimal,
} from "../utils/format";

// Ficha "Tu próximo Toyota": Propulsión / Rendimiento / Combustible / CO₂.
const VehicleSpecs = ({ version }) => {
    if (!version) return null;

    const unit = efficiencyUnit(version.fuel_type).replace(/\s/g, "");

    return (
        <dl className="savings-calculator__specs">
            <div className="savings-calculator__spec">
                <dt>Propulsión</dt>
                <dd>{version.motor || "—"}</dd>
            </div>
            <div className="savings-calculator__spec">
                <dt>Rendimiento</dt>
                <dd>
                    {formatDecimal(version.efficiency)} {unit}
                </dd>
            </div>
            <div className="savings-calculator__spec">
                <dt>Combustible</dt>
                <dd>{FUEL_LABELS[version.fuel_type] || "—"}</dd>
            </div>
            <div className="savings-calculator__spec">
                <dt>Emisiones CO₂</dt>
                <dd>
                    {version.co2_emissions_g_per_km != null
                        ? `${formatDecimal(version.co2_emissions_g_per_km, 0)} g/km`
                        : "—"}
                </dd>
            </div>
        </dl>
    );
};

export default VehicleSpecs;
